export default __webpack_public_path__ + "static/header-d62691007066d37942ed03e857b707ede21880b41458f3f6b4829a114f765511.png";